import { useEffect } from 'react';
import { useAppContext } from '../context/AppContext';

/**
 * Custom hook to handle embedded page logic for WordPress integration
 * Automatically hides bottom nav and provides return URL functionality
 */
export const useEmbeddedPage = () => {
  const { setHideBottomNav, setCurrentTab } = useAppContext();

  // Whitelist of allowed return URL domains
  const ALLOWED_RETURN_DOMAINS = ['outdoorec.com', 'www.outdoorec.com'];

  const isValidReturnUrl = (url) => {
    try {
      const urlObj = new URL(url);
      // Only allow http and https protocols
      if (!['http:', 'https:'].includes(urlObj.protocol)) {
        return false;
      }
      // Check if domain is in whitelist
      return ALLOWED_RETURN_DOMAINS.some(domain => 
        urlObj.hostname === domain || urlObj.hostname.endsWith('.' + domain)
      );
    } catch {
      return false;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isEmbedded = params.get('embedded') === 'true' || params.get('wordpress') === 'true';
    setHideBottomNav(isEmbedded);

    // Cleanup: restore bottom nav when leaving page
    return () => {
      setHideBottomNav(false);
    };
  }, [setHideBottomNav]);

  const handleBack = () => {
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get('return');
    
    // Only redirect if URL is valid and whitelisted
    if (returnUrl && isValidReturnUrl(returnUrl)) {
      window.location.href = decodeURIComponent(returnUrl);
    } else {
      setCurrentTab('Home');
    }
  };

  return { handleBack };
};
